<template>
  <v-main>
    <div class="mx-auto aa">
      <v-container>
        <v-card color="basil">
          <v-card-title class="text-center justify-center">
            <span
              :class="{'text-h4 ': $vuetify.breakpoint. smAndDown, 'text-h2': $vuetify.breakpoint. mdAndUp}"
              class="basil--text font-weight-bold"
            >UK Salary Calculator</span>
          </v-card-title>
          <!-- <v-card-subtitle>version 0.2 - includes ci/cd through Travis</v-card-subtitle> -->
          <div class="mb-2" style="background: rgba(232, 232, 179, 0.54)">
            <panel-text-main v-if="!onMobile" v-on:setRequired="setRequired"></panel-text-main>
            <panel-text-mobile v-if="onMobile"></panel-text-mobile>
            <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
              <panel-slider v-if="!onMobile && showSlider"></panel-slider>
            </transition>
          </div>

          <!-- create a white seperator -->
          <div class="my-2" style="background: white; height: 10px"></div>
          <v-tabs class="pa-0" v-model="tab" background-color="white" color="basil" grow>
            <v-tab v-for="item in getTabHeaders" :key="item.key">{{ item.value }}</v-tab>

            <v-tab-item :value="0">
              <table-breakdown></table-breakdown>
            </v-tab-item>

            <v-tab-item :value="1">
              <panel-doughnut></panel-doughnut>
            </v-tab-item>

            <v-tab-item :value="2">
              <panel-chart></panel-chart>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-container>
    </div>
  </v-main>
</template>

<script>
import PanelTextMain from "@/components/PanelInputTextMain";
import PanelTextMobile from "@/components/PanelInputTextMobile";
import PanelSlider from "@/components/PanelInputSlider";
import TableBreakdown from "@/components/PanelTableBreakdown";
import PanelChart from "@/components/PanelChart";
import PanelDoughnut from "@/components/PanelDoughnut";

export default {
  components: {
    PanelTextMain,
    PanelTextMobile,
    PanelSlider,
    TableBreakdown,
    PanelChart,
    PanelDoughnut
  },

  data() {
    return {
      tab: 0,
      showSlider: false
      //items: this.getTabHeaders
    };
  },
  methods: {
    setRequired(mode) {
      console.log("parent " + mode);
      this.showSlider = mode == "gross";
    },
    enter(element) {
      const width = getComputedStyle(element).width;

      element.style.width = width;
      element.style.position = "absolute";
      element.style.visibility = "hidden";
      element.style.height = "auto";

      const height = getComputedStyle(element).height;

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      const height = getComputedStyle(element).height;

      element.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    }
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    getTabHeaders() {
      let min = this.$store.getters.getRangeMin;
      let max = this.$store.getters.getRangeMax;
      let minmax = `(${min}k - ${max}k)`;

      let a = {
        key: 0,
        value: this.onMobile ? "Breakdown" : "Detailed Breakdown"
      };
      let b = { key: 1, value: this.onMobile ? "Breakdown" : "Breakdown" };
      let c = {
        key: 2,
        value: this.onMobile ? "Chart" : "General Chart " + minmax
      };
      if (this.onMobile) return [a, b];
      return [a, b, c];
    }
  },
  mounted() {
    // be carefull - this is fixed after it is initialised...
    let onMobile = this.$vuetify.breakpoint.xsOnly;
    this.$store.commit("SET_ON_MOBILE", onMobile);
    this.$store.dispatch("setGrossIncome", 18000);
  }
};

function calcBand(vm, amount, tax) {
  vm.tax += amount * (tax / 100);
  vm.takehome = vm.gross - vm.tax;
}
</script>

<style scoped>
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>

<style>
.aa {
  max-width: 1100px;
  background-color: transparent;
}

.basil {
  background-color: white !important;
}
.basil--text {
  color: #356859 !important;
}

.expand-enter-active,
.expand-leave-active {
  transition: height 0.5s ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}
</style>